import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ImageBlock } from "./image_block";
export const ImagesBlock = (p)=>/*#__PURE__*/ _jsx("section", {
        className: "block block--image-grid",
        children: /*#__PURE__*/ _jsx("ul", {
            className: "row block__list",
            children: p.images.map((i, k)=>/*#__PURE__*/ _jsx("li", {
                    className: "block__item col-xs-12 col-sm-6 col-md-4",
                    children: /*#__PURE__*/ _jsx(ImageBlock, {
                        ...i
                    })
                }, `images-${k}`))
        })
    });
